import * as React from 'react';

import { useCallbackRef } from './useCallbackRef';

export function useEscapeKey(handler: () => void, active = true): void {
  const onEscape = useCallbackRef(handler);

  React.useEffect(() => {
    if (!active) return undefined;

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === 'Escape' || event.key === 'Esc') {
        onEscape();
      }
    };

    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [active, onEscape]);
}
